module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_6005.68ed8321.png";